<template>
  <Header v-if="layout?.display?.header" />
  <Banner v-if="layout?.display?.banner" />
  <div class="min-h-screen" :class="[layout?.class?.body]">
    <a-config-provider :theme="theme">
      <slot />
    </a-config-provider>
  </div>
</template>

<script setup lang="ts">
import { LayoutEnum } from "@/configs/enum";
import { theme } from "@/configs/theme";
import Banner from "@/layouts/Banner.vue";
import Header from "@/layouts/Header.vue";
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import type { Layout } from "./type";

const route = useRoute();

const layout = ref<Layout>();

const updateLayout = (metaLayout: string) => {
  switch (metaLayout) {
    case LayoutEnum.PRIMARY_LAYOUT:
      layout.value = {
        display: { header: true, banner: true },
        class: { body: "container px-4 mx-auto pb-10 flex flex-col" },
      };
      break;
    case LayoutEnum.SECONDARY_LAYOUT:
      layout.value = {
        display: { header: true, banner: false },
        class: { body: "container px-4 mx-auto pt-28 pb-10 flex flex-col" },
      };
      break;
    case LayoutEnum.BLANK_BG_CRIMSON_LAYOUT:
      layout.value = {
        display: { header: false, banner: false },
        class: { body: "bg-crimson grid place-content-center" },
      };
      break;
    case LayoutEnum.BLANK_LAYOUT:
    default:
      layout.value = {
        display: { header: false, banner: false },
        class: { body: "" },
      };
      break;
  }
};

watch(
  () => route.meta?.layout as string,
  (metaLayout) => {
    updateLayout(metaLayout);
  },
  { immediate: true },
);
</script>
